// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"3abdb782","167":"578f458c","281":"f67a5148","746":"0aba7ab7","845":"1f6c4d3e"}[chunkId] + ".chunk.css";
};